import React, { useEffect } from "react";
import { getDeviceDetails } from "../../api/utils";
import { Outlet, useSearchParams } from "react-router-dom";
import leftsquarearrow from "../../assets/images/leftsquarearrow.png";
import rightsquarearrow from "../../assets/images/rightsquarearrow.png";
import squarebannerqr from "../../assets/images/squarebannerqr.png";
import { AppstoreButton, Logox2, PlaystoreButton } from "../../assets/svg";
import DownloadAppPopup from "../downloadapppopup/downloadapppopup";
import mobileImagesSrc from "../../assets/images/mobiles.png";
import useDownloadAppPopupStore from "../downloadapppopup/downloadapppopupstore";

export const APKUrl =
  "https://play.google.com/store/apps/details?id=com.athletify.strikieapp";
export const IOSUrl = "https://apps.apple.com/in/app/strikie/id6739556725";

const deviceDetails = getDeviceDetails();

export const getAppFunctionForStaticButtons = (value = true) => {
  if (deviceDetails.osType === "Android")
    window.open(window.location + "?getapp=true", "_blank");
  else if (deviceDetails.osType === "iOS")
    window.open(window.location + "?getapp=true", "_blank");
  else {
    if (value) useDownloadAppPopupStore.setState({ show: true });
  }
};

export const GooglePlayButton = ({ url }) => {
  return (
    <PlaystoreButton
      onClick={() => window.open(url, "_blank")}
      className="cursor-pointer"
    />
  );
};

export const AppStoreButton = ({ url }) => {
  return (
    <AppstoreButton
      onClick={() => window.open(url, "_blank")}
      className="cursor-pointer"
    />
  );
};

export const CheckApp = () => {
  const [searchParams] = useSearchParams();
  const getApp = searchParams.get("getapp");

  if (getApp) {
    if (deviceDetails.osType === "Android") window.location.href = APKUrl;
    else if (deviceDetails.osType === "iOS") window.location.href = IOSUrl;
    else window.location.href = "/home";
  }

  return (
    <>
      <Outlet />
      <DownloadAppPopup />
    </>
  );
};

const ContiuneButton = () => {
  if (deviceDetails.browser === "Mobile Safari") return null;
  return (
    <div className="sticky top-0 z-20 bg-black w-full flex items-center justify-between px-2 py-4">
      <div className="flex items-center">
        <div
          className="w-[50px] h-[50px] rounded-lg"
          style={{
            backgroundImage: "url('/android-chrome-192x192.png')",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <div className="ml-3">
          <p className="text-sm">Open in the Strikie app</p>
        </div>
      </div>

      <div>
        <a
          href={window.location.pathname + "?getapp=true"}
          target="_blank"
          rel="noreferrer"
          className="bg-gradient-to-r from-pinkish to-purpleish max-w-fit px-4 py-2 rounded-3xl lg:text-base disabled:opacity-50"
        >
          Continue
        </a>
      </div>
    </div>
  );
};

const RectangleBanner = ({ className }) => {
  return (
    <div className={`px-2 py-4 bg-[#111111] ${className}`}>
      <div className="rounded-lg shadow-lg">
        <div className="flex items-center justify-between gap-4 flex-wrap">
          <div className="flex items-center">
            <div
              className="w-[60px] h-[60px] rounded-lg"
              style={{
                backgroundImage: "url('/android-chrome-192x192.png')",
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            />
            <div className="ml-3">
              <h3 className="text-white font-semibold">Strikie</h3>
              <p className="text-sm">Download the Strikie app</p>
            </div>
          </div>
          <div className="flex items-center flex-nowrap justify-center gap-4">
            {deviceDetails.osType === "Android" ? (
              <GooglePlayButton url={APKUrl} />
            ) : deviceDetails.osType === "iOS" ? (
              <AppStoreButton url={IOSUrl} />
            ) : (
              <>
                <GooglePlayButton url={APKUrl} />
                <AppStoreButton url={IOSUrl} />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const Topbanner = ({ className = "" }) => {
  if (deviceDetails.osType === "Android" || deviceDetails.osType === "iOS") {
    return <ContiuneButton />;
  }

  return (
    <RectangleBanner className={`${className} sticky top-0 left-1/2 z-20`} />
  );
};

export const SquareBanner = () => {
  useEffect(() => {
    document.body.classList.add("bg-hero-image");

    const handleRedirect = () => {
      if (deviceDetails.osType === "Android") window.open(APKUrl, "_blank");
      else if (deviceDetails.osType === "iOS") window.open(IOSUrl, "_blank");
    };

    if (deviceDetails.osType === "Android" || deviceDetails.osType === "iOS") {
      document.body.addEventListener("click", handleRedirect);
      document.body.addEventListener("scroll", handleRedirect);
      // document.body.addEventListener("touchend", handleRedirect);
    }

    // setTimeout(() => {
    // if (deviceDetails.osType === "Android") window.open(APKUrl, "_blank");
    // else if (deviceDetails.osType === "iOS") window.open(IOSUrl, "_blank");
    // }, 2000);
    return () => {
      document.body.classList.remove("bg-hero-image");
      if (
        deviceDetails.osType === "Android" ||
        deviceDetails.osType === "iOS"
      ) {
        document.body.removeEventListener("click", handleRedirect);
        document.body.removeEventListener("scroll", handleRedirect);
        // document.body.removeEventListener("touchend", handleRedirect);
      }
    };
  }, []);

  return (
    <div className="w-screen relative">
      <div className="flex justify-between items-start w-full mb-3 absolute top-0">
        <img
          alt="rightsquarearrow"
          src={rightsquarearrow}
          className="sm3:max-w-[80px] sm2:max-w-[105px] max-w-[60px]"
        />
        <img
          alt="leftsquarearrow"
          src={leftsquarearrow}
          className="sm3:max-w-[80px] sm2:max-w-[105px] max-w-[60px]"
        />
      </div>
      <div className="flex justify-center w-full">
        <Logox2 className="flex-shrink-0 my-4" />
      </div>
      <div className="flex items-center justify-center gap-10 px-5 md:flex-nowrap flex-wrap-reverse">
        <div className="w-full max-w-[500px] h-fit flex flex-col items-center flex-shrink-0 rounded-xl overflow-hidden relative">
          <div className="p-6 rounded-xl max-w-[220px] md:max-w-[300px] mt-8 bg-white hidden md:block">
            <img alt="bannerqr" src={squarebannerqr} />
          </div>
          <div className="text-3xl text-center mt-3 hidden md:block">
            <p>Scan QR to Board Your Sports Journey</p>
          </div>
          <div className="text-xl text-center mt-3 block md:hidden">
            <p>Download to Board Your Sports Journey</p>
          </div>
          <div className="items-center gap-3 w-full my-3 mx-3 text-[#444444] hidden md:flex">
            <span className="border border-[#444444] flex-grow"></span>
            <span>Or</span>
            <span className="border border-[#444444] flex-grow"></span>
          </div>
          <div className="font-semibold text-black text-xl text-center md:mb-3">
            <p className="text-white">Available on</p>
          </div>
          <div className="text-center flex items-center justify-center md:mt-6 gap-5 w-full mx-10">
            <GooglePlayButton url={APKUrl} />
            <AppStoreButton url={IOSUrl} />
          </div>
        </div>

        <div className="max-h-[540px]">
          <img
            alt="mobileimages"
            src={mobileImagesSrc}
            className="md:max-h-[540px] max-h-[50vh]"
          />
        </div>
      </div>
    </div>
  );
};

export default Topbanner;
